/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    em: "em",
    hr: "hr",
    ul: "ul",
    li: "li",
    a: "a",
    blockquote: "blockquote",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "What do I need to do to migrate to v5?"
    }), "\n", _jsx(_components.p, {
      children: "Ready for this?"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-sh",
        children: "npm install styled-components@^5.0.0 react@^16.8 react-dom@^16.8 react-is@^16.8\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "If you're using React Native, you'll need at least v0.59 (the first version to support hooks.)"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.em, {
        children: "That's it."
      }), " 💥"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.p, {
      children: "styled-components v5 does not introduce any breaking public API changes, and adds the following:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Total rewrite of the core stylesheet engine, tuned for performance"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "New hooks-based component model"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "StyleSheetManager"
          }), " has new props:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.code, {
              children: "disableCSSOMInjection"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.code, {
              children: "disableVendorPrefixes"
            })
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "stylisPlugins"
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: ["try it with ", _jsx(_components.a, {
                  href: "https://www.npmjs.com/package/stylis-plugin-rtl",
                  children: _jsx(_components.code, {
                    children: "stylis-plugin-rtl"
                  })
                }), " for your bidi needs!"]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Note: The subfunction object-form ", _jsx(_components.code, {
          children: ".attrs({ prop: props => {} })"
        }), " syntax that was deprecated in v4 is removed in v5. Use function-form attrs instead ", _jsx(_components.code, {
          children: ".attrs(props => ({}))"
        }), " (you should have been seeing console warnings to make this update ahead of time.)"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Check out the ", _jsx(_components.a, {
        href: "https://medium.com/styled-components/389747abd987",
        children: "official announcement post"
      }), " for more information and to learn about what went into v5!"]
    }), "\n", _jsx(_components.h3, {
      children: "For jest users"
    }), "\n", _jsx(_components.p, {
      children: "Update to jest-styled-components v7:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-sh",
        children: "npm install jest-styled-components@^7.0.0\n"
      })
    }), "\n", _jsxs(_components.h3, {
      children: ["Note regarding css ", _jsx(_components.code, {
        children: "@import"
      }), " and ", _jsx(_components.code, {
        children: "createGlobalStyle"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["At this time we do not recommend using ", _jsx(_components.code, {
        children: "@import"
      }), " within cGS due to some issues with how browsers process ", _jsx(_components.code, {
        children: "@import"
      }), " via the CSSOM APIs. Instead it's best to place these in your core ", _jsx(_components.code, {
        children: "index.html"
      }), " file (generated or static) within a typical ", _jsx(_components.code, {
        children: "<style>"
      }), " tag."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
